import Vue from 'vue'
import VueRouter from 'vue-router'
import Demo from '../views/Demo.vue'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import Contact from '../views/Contact.vue'
import Customers from '../views/Customers.vue'
import Documents from '../views/Documents.vue'
//import firebase from '@/firebaseinit.js'
//import { getAuth, onAuthStateChanged } from "firebase/auth";
//const auth = getAuth(firebase);

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Kezdőlap',
    component: Home
  },
  {
    path: '/demo',
    name: 'Demo Alkalmazás',
    component: Demo,
    //beforeEnter: redirectIfNotAuth
  },
  {
    path: '/ugyfelek',
    name: 'Ügyfelek',
    component: Customers
  },
  {
    path: '/nyomtatvanyok',
    name: 'Meghatalmazás',
    component: Documents
  },
  {
    path: '/login',
    name: 'Bejelentkezés',
    component: Login
  },
  {
    path: '/kapcsolat',
    name: 'Kapcsolat',
    component: Contact
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

/*
async function redirectIfNotAuth (to, from, next) {
  await onAuthStateChanged(auth, (user) => {
    if (!user && to.path !== '/login') next('login')
    else next()
  });
}
*/

/*
router.beforeEach(async (to, from, next) => {
  await onAuthStateChanged(auth, (user) => {
    if (to.path !== '/' && (!user && to.path !== '/login')) next('login')
    else next()
  });
})
*/
export default router
